import { render, staticRenderFns } from "./memberPostTable.vue?vue&type=template&id=e591d6d8&"
import script from "./memberPostTable.vue?vue&type=script&lang=js&"
export * from "./memberPostTable.vue?vue&type=script&lang=js&"
import style0 from "./memberPostTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports